<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.margin-tb-5 {
  margin: 5px 0;
}

/deep/ .order-no-link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #66b1ff;
    text-decoration: underline;
  }
}

.force-close-tip {
  color: #606266;
  font-size: 14px;
  margin-bottom: 16px;
}

.force-close-order-info {
  background: #f5f7fa;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;

  p {
    margin: 6px 0;
    font-size: 14px;
  }

  .label {
    color: #909399;
    margin-right: 4px;
  }
}

.force-close-settlement-type {
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #ebeef5;

  &.normal {
    background: #f0f9eb;
    border-color: #c2e7b0;
  }

  &.offline {
    background: #fdf6ec;
    border-color: #f5dab1;
  }

  .settlement-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .settlement-title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .settlement-desc {
    font-size: 14px;
    color: #606266;
    line-height: 1.5;
    margin: 0;
  }
}

/* 操作列按钮样式优化 */
/deep/ .list-table {
  .settlement-btn-normal {
    background: linear-gradient(90deg, #4182eb, #67bcfb) !important;
    border: none !important;
    color: #fff !important;
    padding: 5px 12px;
    font-size: 12px;

    &:hover {
      opacity: 0.9;
    }
  }

  .settlement-btn-offline {
    background: #fff !important;
    border: 1px solid #dcdfe6 !important;
    color: #606266 !important;
    padding: 5px 12px;
    font-size: 12px;

    &:hover {
      color: #4182eb !important;
      border-color: #4182eb !important;
    }
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">{{ '共享充电订单' }}</div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="listDetailFun('check')">查 看</button>
        <!-- <button class="common-bg-button" @click="listDetailFun('edit')">编 辑</button> -->
        <button class="common-bg-button" @click="toHandelRecord()">查看日志</button>
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true, isNormal)">
          搜 索
        </button>
        <button class="common-bg-button" @click="toExportList">
          导 出
        </button>
        <button class="common-bg-button" @click="() => { showMultiQuerys = !showMultiQuerys }">高级筛选</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电用户手机号</p>
              <el-input clearable v-model="queryInfo.userPhone" size="small" placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">桩主用户手机号</p>
              <el-input clearable v-model="queryInfo.custMobile" size="small" placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">共享充电订单编号(ID)</p>
              <el-input clearable v-model="queryInfo.orderNo" size="small" placeholder="请输入订单共享充电订单编号(ID)"></el-input>
            </el-col>
            <!-- <el-col :span="6">
                <p class="margin-tb-5 font-14">账号类型</p>
                <el-input clearable v-model="queryInfo.shareStartTypeName" size="small" placeholder="请输入账号类型"></el-input>
              </el-col> -->
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电桩IMEI编号</p>
              <el-input clearable v-model="queryInfo.pileCode" size="small" placeholder="请输入充电桩IMEI编号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.shareOrderStatus" size="small" filterable class="full-width" clearable
                placeholder="请选择" :disabled='!isNormal'>
                <el-option v-for="item in statusList" :key="item.configVal" :label="item.configName"
                  :value="item.configVal"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">订单类型</p>
              <el-select v-model="queryInfo.orderProperty" size="small" class="full-width" clearable placeholder="请选择">
                <el-option label="正常" value="01"></el-option>
                <el-option label="异常" value="02"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">订单属性</p>
              <el-select v-model="queryInfo.shareOrderType" size="small" class="full-width" clearable placeholder="请选择">
                <el-option label="自用" value="OWNER"></el-option>
                <el-option label="共享" value="SHARE"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">结束方式</p>
              <el-input clearable v-model="queryInfo.chargeOverReason" size="small" placeholder="请输入结束方式"></el-input>
              <!-- <el-select v-model="queryInfo.chargeOverReason" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="拔枪" value="拔枪"></el-option>
                <el-option label="车主动断开" value="车主动断开"></el-option>
                <el-option label="指令" value="指令"></el-option>
                <el-option label="充满" value="充满"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="桩故障" value="桩故障"></el-option>
              </el-select> -->
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电时间</p>
              <div class="flex-r">
                <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="chargeTime" @change="pickdate(chargeTime)" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" v-if="!isNormal">
              <p class="margin-tb-5 font-14">异常处理状态</p>
              <el-select v-model="queryInfo.processingStatus" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="已处理" value="Y"></el-option>
                <el-option label="未处理" value="N"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table" ref="tableContainer" @click="handleTableClick">
        <ZD-table :tableColumns="listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }" />
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData(pagination, false, isNormal)" />
      </div>
    </div>
    <!-- 确认强制关闭订单弹窗 -->
    <el-dialog title="确认强制关闭订单" :visible.sync="forceCloseDialog.visible" width="480px" :close-on-click-modal="false">
      <p class="force-close-tip">此操作将强制关闭无法自动结算的订单，请确认操作类型。</p>
      <div class="force-close-order-info" v-if="forceCloseDialog.row">
        <p><span class="label">订单编号：</span>{{ forceCloseDialog.row.orderNo || '-' }}</p>
        <p><span class="label">用户信息：</span>{{ forceCloseDialog.row.custPhone || forceCloseDialog.row.custName || '-' }}
        </p>
        <p><span class="label">充电量：</span>{{ forceCloseDialog.row.chargeVal ?? '-' }} kWh</p>
        <p><span class="label">充电实付费用(元)：</span>¥{{ forceCloseDialog.row.actPayFee ?? '-' }}
        </p>
      </div>
      <div class="force-close-settlement-type" :class="forceCloseDialog.type">
        <div class="settlement-header">
          <span class="settlement-title">{{ forceCloseDialog.type === 'normal' ? '正常结算' : '线下结算' }}</span>
          <el-tag size="mini" :type="forceCloseDialog.type === 'normal' ? 'success' : 'warning'">
            {{ forceCloseDialog.type === 'normal' ? '自动' : '手动' }}
          </el-tag>
        </div>
        <p class="settlement-desc">
          {{ forceCloseDialog.type === 'normal'
            ? '订单将按照正常流程自动结算并扣费，完成后订单状态将更新为已完成。'
            : '订单将转为线下结算的异常订单，系统会自动原路退回预付费用，需要桩主与用户协商线下支付。' }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="forceCloseDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmForceClose">
          {{ forceCloseDialog.type === 'normal' ? '确认正常结算' : '确认线下结算' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 操作日志 -->
    <el-dialog title="操作日志" width="60%" :visible.sync="handelRecordObj.showDialog">
      <el-table class="el-table" :data="handelRecordObj.tableData" border max-height="600px"
        style="width: 100%;margin:20px auto"
        :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
        <el-table-column prop="lastModifiedByName" width="80" label="操作人">
        </el-table-column>
        <el-table-column prop="lastModifiedWhen" width="160" label="更改时间">
        </el-table-column>
        <el-table-column prop="data" min-width="300" label="更改数据">
        </el-table-column>
      </el-table>
      <div class="list-pagination">
        <ZD-pagination :pagination="handelRecordObj.pagination" v-on:pageUpdate="toHandelRecord" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      listColumns: [],
      pagination: pageConfig.pagination,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      queryInfo: {}, //初始化数据
      showMultiQuerys: false,
      isNormal: true,
      chargeTime: [],
      statusList: [
        {
          configVal: 'PAYED',
          configName: '已支付',
        },
        {
          configVal: 'CHARGING',
          configName: '充电中',
        },
        {
          configVal: 'FINISHED',
          configName: '已完成',
        },
        {
          configVal: 'REFUNDING',
          configName: '退款中',
        },
        {
          configVal: 'CLOSED',
          configName: '已关闭',
        },
        {
          configVal: 'ABNORMAL',
          configName: '异常',
        },
      ],
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          {
            id: 'offlineSettlement',
            label: '线下结算',
            type: 'default',
            plain: false,
            btnClass: 'settlement-btn-offline',
            show: (row) => row.shareOrderStatus === 'CHARGING',
            method: (index, row) => {
              this.openForceCloseDialog(row, 'offline');
            },
          },
          {
            id: 'normalSettlement',
            label: '正常结算',
            type: 'primary',
            plain: false,
            btnClass: 'settlement-btn-normal',
            show: (row) => row.shareOrderStatus === 'CHARGING',
            method: (index, row) => {
              this.openForceCloseDialog(row, 'normal');
            },
          },
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },

          // {
          //   id: 'charge',
          //   label: '充电记录',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     debugger
          //     this.$store.commit('setEditId', row.pileCode)
          //     // this.$router.push({ name: pageConfig.chargeDetailRouter });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.chargeDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'fault',
          //   label: '故障记录编辑',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.id)
          //     // this.$router.push({ name: pageConfig.faultDetail });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.faultDetail }).href,
          //       '_blank'
          //     )
          //   }
          // },
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
      handelRecordObj: {
        showDialog: false,
        tableData: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
        },
      },
      forceCloseDialog: {
        visible: false,
        row: null,
        type: 'normal', // 'normal' | 'offline'
      },
    }
  },
  methods: {
    //查找站点名称 获取数据
    init() {
      // 初始化列配置，为共享充电订单ID添加formatter
      this.initColumns()
      this.getListData(this.pagination, true, this.isNormal)
    },
    // 初始化列配置
    initColumns() {
      const _ = this
      this.listColumns = pageConfig.listColumns.map(column => {
        if (column.props === 'orderNo') {
          return {
            ...column,
            formatter: (row) => {
              const orderNo = row.orderNo || ''
              const isWhitelistOrder = row.isWhitelistOrder || ''
              // 使用data属性存储orderNo和白名单标记，通过事件委托处理点击
              return `<span class="order-no-link" data-order-no="${orderNo}" data-is-whitelist="${isWhitelistOrder}">${orderNo}</span>`
            }
          }
        }
        return column
      })
    },
    // 处理订单号点击事件
    handleOrderNoClick(orderNo, isWhitelistOrder) {
      const routeUrl = this.$router.resolve({
        name: 'sharedChargingDetail',
        query: { orderNo: orderNo, isWhitelistOrder: isWhitelistOrder || '' }
      })
      window.open(routeUrl.href, '_blank')
    },
    // 获取表格数据
    getListData(pagination, reload = false, isNormal = true) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.digitization.chargePileOrderList, _.queryInfo).then(res => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },
    // 查看详情
    listDetailFun() {
      let _ = this
      if (_.checkSelectOne(_.selections)) {
        let routeUrl = this.$router.resolve({
          name: 'sharedChargingDetail',
          query: {
            orderNo: _.selections[0].orderNo,
            isWhitelistOrder: _.selections[0].isWhitelistOrder || ''
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    pickdate(time) {
      let _ = this;
      _.queryInfo.useShareChargeStartDate = time ? time[0] : ''
      _.queryInfo.useShareChargeEndDate = time ? time[1] : ''
    },
    toHandelRecord() {
      let _ = this;
      let obj = {
        pageNum: _.handelRecordObj.pagination.current - 1,
        pageSize: _.handelRecordObj.pagination.pageSize,
        webType: 'pileOrder'
      }
      _.$H.post(_, _.$A.digitization.webLog, obj).then(res => {
        _.handelRecordObj.tableData = res.data.data.content || [];
        _.handelRecordObj.pagination.total = res.data.data.totalElements || 0;
        _.handelRecordObj.showDialog = true;
      })
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      this.pagination.current = 1
      this.$nextTick(() => {
        this.getListData(this.pagination, true, this.isNormal)
      })
    },
    // 导出
    toExportList() {
      let _ = this
      const params = {
        ..._.queryInfo,
        pageNum: 0,
        pageSize: this.pagination.pageSize,
        corpNo: _.$store.state.corpNo,
      }
      _.$U.showLoading(_)
      axios
        .post(_.$A.digitization.exportDeviceShareLockOrder, params, {
          responseType: 'blob',
          headers: {
            authorization: _.$store.state.token,
          },
        })
        .then((res) => {
          const disposition = res.headers['content-disposition'] || ''
          const match = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/)
          const fileName = decodeURIComponent(match?.[1] || match?.[2] || '共享充电订单列表.xlsx')
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .finally(() => {
          _.$U.hideLoading(_)
        })
    },
    // 处理表格点击事件（事件委托）
    handleTableClick(event) {
      const target = event.target
      if (target && target.classList.contains('order-no-link')) {
        const orderNo = target.getAttribute('data-order-no')
        const isWhitelistOrder = target.getAttribute('data-is-whitelist') || ''
        if (orderNo) {
          this.handleOrderNoClick(orderNo, isWhitelistOrder)
        }
      }
    },
    // 打开强制关闭订单弹窗
    openForceCloseDialog(row, type) {
      this.forceCloseDialog.row = row;
      this.forceCloseDialog.type = type;
      this.forceCloseDialog.visible = true;
    },
    // 确认强制关闭
    confirmForceClose() {
      const _ = this;
      const { row, type } = _.forceCloseDialog;
      const apiUrl = type === 'normal' ? _.$A.digitization.normalSettle : _.$A.digitization.abnormalSettle;
      _.$U.showLoading(_);
      _.$H.post(_, apiUrl, { orderNo: row.orderNo }).then(() => {
        _.$message.success(type === 'normal' ? '正常结算成功' : '线下结算成功');
        _.forceCloseDialog.visible = false;
        _.getListData(_.pagination, true, _.isNormal);
      }).catch(() => { }).finally(() => {
        _.$U.hideLoading(_);
      });
    },
  },
  mounted() {
    this.init()
  },
  watch: {}
}
</script>
